/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'
import React, { useMemo, useRef, useState } from 'react'
import GeneratePluginModal from 'src/components/GeneralPluginModal'
import { NewModal } from 'src/components/NewModal'
import OrganizationModal from 'src/components/OrganizationModal'
import { useSelector } from 'src/hooks/useRedux'
import Page from '../../components/Page'
import OrgListTable from './OrgListTable'

const Organizations = () => {
  const [orgCount, setOrgCount] = useState('')
  const [refreshKey, setRefreshKey] = useState(0)
  const generatePluginTagModalRef = useRef(null)
  const [selectedSchedule, setSelectedSchedule] = useState(null)
  const onClickWebPluginOnScheduleList = (schedule) => {
    setSelectedSchedule(schedule)
    generatePluginTagModalRef?.current?.openModal()
  }
  const [organizationModalOpen, setOrganizationModalOpen] = useState(false)
  const [organization, setOrganization] = useState(null)

  const account = useSelector((state) => state.account._meAccount)

  const triggerRefresh = () => {
    setRefreshKey((key) => ++key)
  }

  const actions = useMemo(() => {
    return []
  }, [])

  const pages = useMemo(
    () => [
      {
        to: `${ROUTES.ORGS.ROOT}/my`,
        text: `${t('common:organization_plural', { count: 2 })} ${
          orgCount ? `(${orgCount})` : ''
        }`,
        component: (
          <OrgListTable
            key='orgs'
            slug='/users/me/organizations'
            setCount={setOrgCount}
            refreshKey={refreshKey}
            setInitialState={setOrganization}
            onEditOrg={() => {
              setOrganizationModalOpen(true)
            }}
            onClickWebPluginOnScheduleList={onClickWebPluginOnScheduleList}
          />
        ),
        actions: actions,
      },
      // Commented out - moved to Following page
      // {
      //   to: `${ROUTES.ORGS.FAVOURITES}`,
      //   text: 'following',
      //   component: (
      //     <OrgList
      //       key='favs'
      //       slug='/favorites/organizations'
      //       setCount={() => {
      //         console.log('setFavCount')
      //       }}
      //       setInitialState={setOrganization}
      //       onEditOrg={() => {
      //         setOrganizationModalOpen(true)
      //       }}
      //       isFavorites={true}
      //     />
      //   ),
      // },
    ],
    [orgCount, refreshKey, actions, setOrgCount]
  )

  const BASE_ROUTE = ROUTES.ORGS.ROOT

  return (
    <>
      <Page
        displayMobileActions={false}
        baseRoute={BASE_ROUTE}
        pages={pages}
        baseTitle={t('common:organization_plural', { count: 2 })}
        title={t('util:capitalize', {
          text: t('common:organization_plural', { count: 2 }),
        })}
        isOrgsPage={true}
        hideBreadcrumbs={true}
      />
      <OrganizationModal
        isFormOpen={organizationModalOpen}
        setIsFormOpen={setOrganizationModalOpen}
        organization={organization}
        setOrganization={setOrganization}
        refresh={() => {
          triggerRefresh()
        }}
        account_id={account?.uid}
      />
      <NewModal
        ref={generatePluginTagModalRef}
        shouldCloseOnOverlayClick={false}
      >
        <GeneratePluginModal
          onPressClose={() => {
            generatePluginTagModalRef?.current?.closeModal()
            setSelectedSchedule(null)
          }}
          scheduleId={selectedSchedule?.id}
          isOrganization={true}
        />
      </NewModal>
    </>
  )
}

export default Organizations
